import React from 'react';
import PageLink from 'components/PageLink/PageLink';
import styles from './CompleteAndUpdate.module.scss';

type Props = {
  mainText: string;
  percents?: string | number;
  highlightedText?: string;
  buttonText?: string;
  buttonUrl?: string;
};

const CompleteAndUpdate = ({
  mainText,
  percents,
  highlightedText,
  buttonText,
  buttonUrl,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        {mainText}{' '}
        <em className={styles.highlighted}>
          {percents} % {highlightedText}
        </em>
      </div>
      {buttonUrl && buttonText && (
        <PageLink
          url={buttonUrl}
          text={buttonText}
          className={styles.ctaButton}
        />
      )}
    </div>
  );
};

export default CompleteAndUpdate;
